import { IUserFiles } from "@state/userFiles/types";
import { IImageList, IState } from "../types";
import { copyFile, sendFile } from "@utils/cloudStorage";
import { IElement, IImageAttributes } from "@routes/private/Editor/types";
import { findElementById } from "@utils/editor";
import { getBoundingsWithDelta } from "@utils/geometry";
const uuid = require("react-uuid");

export const getBase64 = (name: string, file: File, userFile: IImageList) => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const result = reader.result?.toString();
      if (result) {
        //updateImageList(imageList, name, 'uploading', {...userFile, src: result});
        //sendFileResponse(name, result);
        resolve(result);
      }
    };
    reader.onerror = function (error) {
      console.error(error);
      reject(error);
    };
  });
};

const getBase64Url = (name: string, url: string, userFile: IImageList) => {
  return new Promise((resolve, reject) => {
    var request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.responseType = "blob";
    request.onload = function () {
      var reader = new FileReader();
      reader.readAsDataURL(request.response);
      reader.onload = function () {
        const result = reader.result?.toString();
        if (result) {
          ////setArrayResult([...arrayresult, result])
          ////updateImageList(imageList, name, 'uploading', {...userFile, src: result});
          //sendFileResponse(name, result);
          resolve(result);
        }
      };
      reader.onerror = function (error) {
        console.error(error);
        reject(error);
      };
    };
    request.send();
  });
  //return "";
};

export const validateFiles = (
  files: File[],
  imageFileTypes: string[],
  setFilesUploaded: (filesUploaded: IState["files"]) => void,
  context: any
) => {
  let errorFiles: string[] = [];
  let newFiles: File[] = [];
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    //DOS-122: Validate image file extensions to exclude *.jfif file that also have  = MIME type image/jpeg
    let fileExt = (file.name.split(".").pop() || "").toLowerCase();
    //if file has jpg or svg as extension then use its MIME type = image/jpeg or image/svg+xml)
    let customFileType =
      fileExt === "jpg" || fileExt === "svg" ? file.type : `image/${fileExt}`;
    if (
      imageFileTypes.includes(file.type) &&
      imageFileTypes.includes(customFileType)
    )
      newFiles = [...newFiles, file];
    else errorFiles = [...errorFiles, file.name];
  }
  if (errorFiles.length > 0) {
    context.onWarningScreenChange(
      true,
      "Upload File Error",
      `The available image types are: jpeg, png and svg.`,
      "",
      undefined,
      "OKAY",
      "Invalid File Type",
      errorFiles
    );
  }
  setFilesUploaded(newFiles);
};

const updateImageListArray = (
  imagesListFrom: IImageList[],
  setImageList: (imageList: IImageList[]) => void,
  fullNames?: string[],
  status?: string,
  newFiles?: IImageList[]
) => {
  let newImageList = [...imagesListFrom];
  if (status == "uploading" && fullNames) {
    fullNames.map((fullName, index) => {
      if (newFiles) {
        let newFile = newFiles[index];
        newImageList = [...newImageList, { ...newFile, status: status }];
      }
    });
  }
  setImageList(newImageList);
};

const sendUploadingFiles = async (
  uploadImages: IImageList[],
  folder: string,
  dispatch: any,
  setFileResponse: (fileResponse: IState["response"]) => void
) => {
  uploadImages.map((img) => {
    if (img.src)
      sendFileResponse(
        `${folder}/${img.id}`,
        img.src,
        dispatch,
        setFileResponse
      );
  });
};

const sendFileResponse = async (
  name: string,
  data: string,
  dispatch: any,
  setFileResponse: (fileResponse: IState["response"]) => void
) => {
  try {
    await sendFile(name, data, dispatch);
    setFileResponse({ name: name, status: 200 });
  } catch (e) {
    setFileResponse({ name: name, status: 400 });
    console.error(e);
  }
};

const convertSendFiles = async (
  filesInput: any[],
  folder: string,
  imageList: IImageList[],
  setImageList: (imageList: IImageList[]) => void,
  dispatch: any,
  setFileResponse: (fileResponse: IState["response"]) => void
) => {
  let newFiles = filesInput.map((fileInput) => {
    return {
      id: uuid(),
      thumbnail: "",
      type: "image",
      date: new Date(),
      src: fileInput,
    };
  });
  let nameFiles = newFiles.map((newFile) => {
    return `${folder}/${newFile.id}`;
  });

  let srcFiles = await Promise.all(
    newFiles.map(async (newFile) => {
      return {
        ...newFile,
        src: await getBase64(`${folder}/${newFile.id}`, newFile.src, newFile),
      };
    })
  );
  updateImageListArray(
    imageList,
    setImageList,
    nameFiles,
    "uploading",
    srcFiles as IImageList[]
  );
  sendUploadingFiles(
    srcFiles as IImageList[],
    folder,
    dispatch,
    setFileResponse
  );
  return newFiles;
};

const convertUrlFiles = async (
  filesInput: any[],
  folder: string,
  imageList: IImageList[],
  setImageList: (imageList: IImageList[]) => void,
  dispatch: any,
  setFileResponse: (fileResponse: IState["response"]) => void
) => {
  let newFiles = filesInput.map((fileInput) => {
    return {
      id: uuid(),
      thumbnail: "",
      type: "image/gallery",
      date: new Date(),
      src: fileInput,
    };
  });

  let nameFiles = newFiles.map((newFile) => {
    return `${folder}/${newFile.id}`;
  });

  let srcFiles = await Promise.all(
    newFiles.map(async (newFile) => {
      return {
        ...newFile,
        src: await getBase64Url(
          `${folder}/${newFile.id}`,
          newFile.src,
          newFile
        ),
      };
    })
  );

  updateImageListArray(
    imageList,
    setImageList,
    nameFiles,
    "uploading",
    srcFiles as IImageList[]
  );
  sendUploadingFiles(
    srcFiles as IImageList[],
    folder,
    dispatch,
    setFileResponse
  );
  return newFiles;
};
export const addNewFiles = async (
  newFiles: any,
  filetype: string,
  context: any,
  authContext: any,
  imageList: IImageList[],
  setImageList: (imageList: IImageList[]) => void,
  dispatch: any,
  setFileResponse: (fileResponse: IState["response"]) => void
) => {
  if (context.userFiles) {
    let newUserFiles = context.userFiles;
    if (filetype == "LOCAL")
      newUserFiles.files = [
        ...newUserFiles.files,
        ...(await convertSendFiles(
          newFiles,
          context.userFiles.id,
          imageList,
          setImageList,
          dispatch,
          setFileResponse
        )),
      ];
    else
      newUserFiles.files = [
        ...newUserFiles.files,
        ...(await convertUrlFiles(
          newFiles,
          context.userFiles.id,
          imageList,
          setImageList,
          dispatch,
          setFileResponse
        )),
      ];
    context.onEditUserFiles(newUserFiles);
  } else {
    const userData = {
      email: authContext?.userData.profile.email
        ? authContext?.userData.profile.email
        : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name
        ? authContext?.userData.profile.name
        : "Default User",
    };
    const userFilesId = uuid();
    let newUserFiles: IUserFiles = {
      id: userFilesId,
      entityType: "USERFILES",
      user: userData,
      files:
        filetype === "LOCAL"
          ? await convertSendFiles(
              newFiles,
              userFilesId,
              imageList,
              setImageList,
              dispatch,
              setFileResponse
            )
          : await convertUrlFiles(
              newFiles,
              userFilesId,
              imageList,
              setImageList,
              dispatch,
              setFileResponse
            ),
    };
    context.onEditUserFiles(newUserFiles);
  }
};

export const handleAddImageManager = (
  itemId: string,
  replace: boolean,
  context: any,
  deltaBorder: number,
  imageListFiltered: IImageList[],
  setNewImageSrc: (newImageSrc: IState["newImageSrc"]) => void,
  dispatch: any
) => {
  if (replace) {
    handleReplaceImage(
      itemId,
      imageListFiltered,
      context,
      setNewImageSrc,
      dispatch
    );
    return;
  }
  let ids: string[] = [];

  if (context.data[0].type === "Artboards") {
    if (
      context.editorStatus.selectedArtboardIds &&
      context.editorStatus.selectedArtboardIds.length > 0
    ) {
      context.editorStatus.selectedArtboardIds.map((id: string) => {
        ids = [...ids, id];
      });
    } else if (
      context.data[0]?.children &&
      context.data[0]?.children.length > 0
    ) {
      context.data[0].children.map((child: IElement) => {
        ids = [...ids, child.id];
      });
    }
    handleAddImage(
      ids,
      itemId,
      imageListFiltered,
      deltaBorder,
      context,
      setNewImageSrc,
      dispatch
    );
  } else {
    handleAddImage(
      [context.data[0].id],
      itemId,
      imageListFiltered,
      deltaBorder,
      context,
      setNewImageSrc,
      dispatch
    );
  }
};

export const handleAddImage = (
  ids: string[],
  itemId: string,
  imageListFiltered: IImageList[],
  deltaBorder: number,
  context: any,
  setNewImageSrc: (newImageSrc: IState["newImageSrc"]) => void,
  dispatch: any,
  coors?: { x: number; y: number },
  elementCoors?: { x: number; y: number }
) => {
  try {
    let newImageElements: IElement[] = [];
    const img = imageListFiltered.filter((image) => image.id === itemId)[0];
    const srcImage = uuid();
    const urls = {
      oldSrc: `${context.userFiles.id}/${itemId}`,
      newSrc: `${context.parsedTreeInfo.id}/${srcImage}.png`,
    };
    let imageWidth = img.initWidth ?? 200;
    let imageHeight = img.initHeight ?? 200;
    const originalWidth = imageWidth,
      originalHeight = imageHeight;
    let elementIds: string[] = [""];
    ids.map((id) => {
      const imageElementId = uuid();
      let parentElement: IElement | undefined = findElementById(
        context.data,
        id
      );
      if (parentElement === undefined) parentElement = context.data[0];
      const recalculatedSizes = getBoundingsWithDelta(
        deltaBorder,
        originalWidth,
        originalHeight,
        parentElement?.attributes?.width,
        parentElement?.attributes?.height
      );
      imageWidth = recalculatedSizes.width;
      imageHeight = recalculatedSizes.height;
      let coorX = parentElement?.attributes?.x;
      let coorY = parentElement?.attributes?.y;
      if (coors && elementCoors) {
        coorX +=
          coors.x * parentElement?.attributes?.width -
          elementCoors.x * imageWidth;
        coorY +=
          coors.y * parentElement?.attributes?.height -
          elementCoors.y * imageHeight;
      } else {
        coorX += parentElement?.attributes?.width / 2 - imageWidth / 2;
        coorY += parentElement?.attributes?.height / 2 - imageHeight / 2;
      }
      const newAtributes: IImageAttributes = {
        x: coorX,
        y: coorY,
        width: imageWidth,
        height: imageHeight,
        srcImage: urls.oldSrc,
        hidden: false,
        image: { x: coorX, y: coorY, width: imageWidth, height: imageHeight },
      };
      const newImageElement: IElement = {
        id: imageElementId,
        name: imageElementId,
        type: "Image",
        attributes: newAtributes,
      };
      newImageElements = [...newImageElements, newImageElement];
      elementIds = [...elementIds, imageElementId];
    });
    context.onCommandChange("addElement", undefined, ids, newImageElements);
    updateSrcImage(
      urls,
      elementIds,
      srcImage,
      {
        width: imageWidth,
        height: imageHeight,
      },
      setNewImageSrc,
      dispatch
    );
  } catch (error) {
    console.error("error:", error);
  }
};

const updateSrcImage = async (
  urls: { oldSrc: string; newSrc: string },
  ids: string[],
  srcImage: string,
  dimensions: { width: number; height: number },
  setNewImageSrc: (newImageSrc: IState["newImageSrc"]) => void,
  dispatch: any
) => {
  await copyFile({ ...urls }, dispatch);
  const values = new Array(ids.length).fill({
    srcImage,
    width: dimensions.width,
    height: dimensions.height,
  });
  setNewImageSrc({ ids, values });
};

const handleReplaceImage = (
  itemId: string,
  imageListFiltered: IImageList[],
  context: any,
  setNewImageSrc: (newImageSrc: IState["newImageSrc"]) => void,
  dispatch: any
) => {
  try {
    const img = imageListFiltered.filter((image) => image.id === itemId)[0];
    const srcImage = uuid();
    const urls = {
      oldSrc: `${context.userFiles.id}/${itemId}`,
      newSrc: `${context.parsedTreeInfo.id}/${srcImage}.png`,
    };
    let imageWidth = img.initWidth ?? 200;
    let imageHeight = img.initHeight ?? 200;
    const ids: string[] = context.editorStatus.selectedElementsId;
    const values = Array(ids.length).fill({
      srcImage: urls.oldSrc,
      width: imageWidth,
      height: imageHeight,
      newSrcImage: srcImage,
    });
    context.onCommandChange("srcImage", undefined, ids, values);
    updateSrcImage(
      urls,
      ids,
      srcImage,
      {
        width: imageWidth,
        height: imageHeight,
      },
      setNewImageSrc,
      dispatch
    );
  } catch (error) {
    console.error(error);
  }
};

export const updateImageList = (
  imagesListFrom: IImageList[],
  setImageList: (imageListFrom: IImageList[]) => void,
  fullName?: string,
  status?: string,
  newFile?: IImageList
) => {
  let newImageList = [...imagesListFrom];
  if (status && fullName) {
    if (status === "uploading" && newFile) {
      newImageList = [...newImageList, { ...newFile, status: status }];
    } else if (status === "uploaded") {
      const name = fullName.split("/")[1];
      const newImageIndex = newImageList.findIndex(
        (image) => image.id === name
      );
      if (newImageIndex >= 0) {
        newImageList = [
          ...newImageList.slice(0, newImageIndex),
          { ...newImageList[newImageIndex], status: status },
          ...newImageList.slice(newImageIndex + 1),
        ];
      }
    }
  }
  setImageList(newImageList);
};
